<template>
  <div>
    <el-table
      class="trade-pair-table"
      :data="tradePairList"
      :row-key="() => Math.random()"
    >
      <el-table-column prop="pair" label="交易对"></el-table-column>
      <!-- <el-table-column label="交易">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            @change="handleStatusChange(scope.row.pair, $event)"
            :value="scope.row.supportTrade"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="tradeFee" label="手续费"> </el-table-column>
      <el-table-column prop="defaultPrecision" label="默认精度">
        <template slot-scope="scope">
          <a @click="handlePrecisionChange(scope.row.pair)">
            {{ scope.row.defaultPrecision }}
            <i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="amountPrecision" label="数量精度">
        <template slot-scope="scope">
          <a @click="handleAmountPrecisionChange(scope.row.pair)">
            {{ scope.row.amountPrecision }}
            <i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <!-- <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            size="small"
            @click="handleRemove(scope.row.pair)"
          ></el-button> -->
          <el-button type="success" size="small" @click="repair(scope.row)"
            >修复</el-button
          >
          <!-- <el-button
            v-if="!scope.row.supportTrade"
            size="small"
            @click="handleTransaction(scope.row.pair)"
            
            >交易对撤单</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handlePageChanged"
    ></pagination>

    <el-dialog
      :title="'k线  ' + symbol + '   交易对修复'"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <!-- <span>选择修复的起止时间</span> -->
      <el-row align="middle">
        <el-col :span="5" style="line-height: 40px"> 修复时间： </el-col>

        <el-col :span="8">
          <el-date-picker
            v-model="value1"
            type="datetime"
            placeholder="选择开始日期时间"
            align="right"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="8">
          <el-date-picker
            v-model="value2"
            type="datetime"
            placeholder="选择终止日期时间"
            align="right"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px" align="middle">
        <el-col :span="5">
          <span style="line-height: 40px">调整倍数：</span>
        </el-col>

        <el-input-number
          v-model="num"
          :precision="2"
          :step="0.1"
          :max="100"
        ></el-input-number>
      </el-row>
      <el-row style="margin-top: 10px" align="middle">
        <el-col :span="5">
          <span style="line-height: 40px">是否删除历史数据：</span>
        </el-col>
        <el-button type="primary" @click="delHistoryData">删除</el-button>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmRepairKline">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <update-list
      :val="chooseOne"
      @refresh="refreshList"
      :pagination="pagination"
    /> -->
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Pagination from "components/pagination";
import SortableMixin from "mixins/SortableMixin";

export default {
  name: "TradePairList",
  mixins: [SortableMixin],
  components: {
    Pagination,
  },
  props: ["area"],
  data() {
    return {
      num: 1,
      dialogVisible: false,
      sortable: ".trade-pair-table",
      currentData: {
        price: "",
        amount: -1,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      obj: {},
      value1: "",
      value2: "",
      symbol: "",
      pair: "",
    };
  },
  mounted() {
    const t = new Date();

  },
  computed: {
    ...mapGetters("klineRepair", ["tradePairList"]),
    ...mapState("klineRepair", ["pagination", "totalCount"]),
  },
  watch: {
    value2: {
      handler(val, oldVal) {
        if (val) {
          this.value2 = val;
        }
      },
      immediate: true,
      deep: true,
    },
    value1: {
      handler(val, oldVal) {
        if (val) {
          this.value1 = val;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions("klineRepair", [
      "updateTradeStatus",
      "remove",
      "transaction",
      "updateDefaultPrecision",
      "updateAmountPrecision",
      "updateSort",
      "list",
      "repairKline",
      "asyncDelHistoryData",
    ]),
    refreshList(data = {}) {
      this.list({
        area: this.area,
        ...data,
      });
    },
    delHistoryData() {
      this.$confirm("此操作将删除该该交易对的历史数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.asyncDelHistoryData(this.symbol);
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.dialogVisible=false
          }else{
             this.$message({
              type: "error",
              message: "删除失败!请重试",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async confirmRepairKline() {
      if (this.value1.valueOf() <= this.value2.valueOf()) {
        const res = await this.repairKline({
          symbol: this.symbol,
          repairStartTime: this.value1.valueOf(),
          repairEndTime: this.value2.valueOf(),
          param: this.num,
        });
        if (res.data == "success") {
          this.dialogVisible = false;
          this.value1 = "";
          this.value2 = "";
          this.$message.success("修复成功");
        } else {
          this.$message.error("修复失败，请重试");
        }
      } else {
        this.$message.error("起始时间不能比终止时间大");
      }
    },
    // handleSetPrice({ pair, status }) {
    //   const h = this.$createElement;
    //   const self = this;
    //   this.$msgbox({
    //     title: '设置',
    //     message: h('p', null, [
    //       h('input', {
    //         class: { 'el-input__inner': true },
    //         style: {
    //           marginBottom: '10px'
    //         },
    //         domProps: {
    //           value: self.value,
    //           placeholder: '开盘价格'
    //         },
    //         on: {
    //           input: function(event) {
    //             self.currentData.price = event.target.value;
    //           }
    //         }
    //       }),
    //       h('input', {
    //         class: { 'el-input__inner': true },
    //         domProps: {
    //           value: self.value,
    //           placeholder: '开盘数量'
    //         },
    //         on: {
    //           input: function(event) {
    //             self.currentData.amount = event.target.value;
    //           }
    //         }
    //       })
    //     ]),
    //     showCancelButton: true,
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     beforeClose: (action, instance, done) => {
    //       if (action === 'confirm') {
    //         instance.confirmButtonLoading = true;
    //         instance.confirmButtonText = '执行中...';
    //         setTimeout(() => {
    //           done();
    //           setTimeout(() => {
    //             instance.confirmButtonLoading = false;
    //           }, 300);
    //         }, 3000);
    //       } else {
    //         done();
    //       }
    //     }
    //   }).then(() => {
    //     this.doUpdateStatus({ pair, status });
    //   });
    // },
    // handleStatusChange(pair, status) {
    //   this.currentData.amount = -1;
    //   this.currentData.price = '';
    //   const message = `确认要${status ? '开启' : '关闭'}交易功能吗？`;

    //   this.$confirm(message, '提示', { type: 'warning ' }).then(() => {
    //     if (status) {
    //       this.$confirm('是否设置开盘价格', '提示', {
    //         type: 'warning ',
    //         confirmButtonText: '设置开盘价',
    //         cancelButtonText: '直接开启'
    //       })
    //         .then(() => {
    //           Promise.resolve().then(() => {
    //             this.handleSetPrice({ pair, status });
    //           });
    //         })
    //         .catch(() => {
    //           this.doUpdateStatus({ pair, status });
    //         });
    //     } else {
    //       this.doUpdateStatus({ pair, status });
    //     }
    //   });
    // },
    // doUpdateStatus({ pair, status }) {
    //   this.updateTradeStatus({
    //     pair,
    //     status,
    //     amount: this.currentData.amount,
    //     price: this.currentData.price
    //   })
    //     .then(() => {
    //       this.$message.success('操作成功！');
    //       this.$emit('refresh');
    //     })
    //     .finally(() => {
    //       this.currentData.amount = -1;
    //       this.currentData.price = '';
    //     });
    // },
    // handleRemove(pair) {
    //   this.$confirm('确认要删除该交易对吗？', '提示', { type: 'warning' }).then(
    //     () => {
    //       this.remove(pair).then(() => {
    //         this.$message.success('删除成功！');
    //         this.$emit('refresh');
    //       });
    //     }
    //   );
    // },
    // handleTransaction(pair) {
    //   this.$confirm('确认要撤销该交易对下的所有订单么？', '提示', {
    //     type: 'warning'
    //   }).then(() => {
    //     this.transaction(pair).then(() => {
    //       this.$message.success('撤单成功！');
    //       this.$emit('refresh');
    //     });
    //   });
    // },
    handlePageChanged(pagination) {
      this.$emit("refresh", pagination);
    },
    handlePrecisionChange(pair) {
      this.$prompt("请输入默认精度", "提示", {
        inputValidator: (value) => {
          return !value || !value.trim() ? "请输入默认精度" : true;
        },
      }).then(({ value }) => {
        this.updateDefaultPrecision({ pair, precision: Number(value) }).then(
          () => {
            this.$message.success("操作成功！");
            this.$emit("refresh");
          }
        );
      });
    },
    // handleAmountPrecisionChange(pair) {
    //   this.$prompt('请输入数量精度', '提示', {
    //     inputValidator: value => {
    //       return !value || !value.trim() ? '请输入数量精度' : true;
    //     }
    //   }).then(({ value }) => {
    //     this.updateAmountPrecision({ pair, precision: Number(value) }).then(
    //       () => {
    //         this.$message.success('操作成功！');
    //         this.$emit('refresh');
    //       }
    //     );
    //   });
    // },
    async repair(item) {
      this.dialogVisible = true;
      this.pair = item.pair;
      this.symbol = item.pair;
      // this.chooseOne = item;
      // this.setUpdaterDialog(true);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    onSort(evt) {
      const { oldIndex, newIndex } = evt;
      const { page, size } = this.pagination;

      if (oldIndex !== newIndex) {
        const pair = this.tradePairList[oldIndex].pair;

        this.updateSort({
          pair,
          orderNo: (page - 1) * size + newIndex + 1,
        }).then(() => {
          this.$message.success("更新成功！");
          this.$emit("refresh");
        });
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
